import React from 'react';
import img from '../images/logo.png';

export default class Header extends React.Component {
    render() {
        let props = this.props.data;
        return (
            <div className="logoSimTitleBlock">
                <div className="logoBlock">
                    <img src={img} className="feedbackLogo" alt="logo" />
                </div>
                <div className="simTitleBlock">
                    <div className="simTitle">{props.title == undefined ? 'Undefined_Title' : props.title}</div>
                    <div className="simGeneratorUserName"><i className="initiateBy">Created By: </i> {props.createdBy == undefined ? "Undefined-User" : props.createdBy}</div>
                </div>
            </div>
        )
    }
}